module.exports = __webpack_public_path__ + "static/media/icon-20-bus.d1eedc1b.svg";